export enum ContactFormType {
	Career = "Career",
	Contact = "Contact",
}
